import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import AmbientBackground from "@/components/landing/AmbientBackground";
import Hero from "@/components/landing/Hero";
import Ticker from "@/components/landing/Ticker";
import ProblemSection from "@/components/landing/ProblemSection";
import WebsiteService from "@/components/landing/WebsiteService";
import Promise from "@/components/landing/Promise";
import Examples from "@/components/landing/Examples";
import Pricing from "@/components/landing/Pricing";
import Comparison from "@/components/landing/Comparison";
import ChangeService from "@/components/landing/ChangeService";
import Process from "@/components/landing/Process";
import ContractTerms from "@/components/landing/ContractTerms";
import Trust from "@/components/landing/Trust";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import WhatsappButton from "@/components/landing/WhatsappButton";
import CookieBanner from "@/components/landing/CookieBanner";
import Admin from "@/components/admin/Admin";
import Impressum from "@/components/pages/Impressum";
import Datenschutz from "@/components/pages/Datenschutz";

function Landing() {
  const lenisRef = useRef(null);
  useEffect(() => {
    const id = setInterval(() => {
      if (lenisRef.current?.lenis) {
        window.__lenis = lenisRef.current.lenis;
        clearInterval(id);
      }
    }, 80);
    return () => clearInterval(id);
  }, []);

  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.09, smoothWheel: true, wheelMultiplier: 1 }}>
      <div className="relative min-h-screen text-[#F4F4F0] font-body antialiased overflow-x-clip" data-testid="app-root">
        <AmbientBackground />
        <div className="grain" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <Ticker />
          <ProblemSection />
          <WebsiteService />
          <Promise />
          <Examples />
          <Pricing />
          <Comparison />
          <ChangeService />
          <Process />
          <ContractTerms />
          <Trust />
          <Faq />
          <FinalCta />
          <Contact />
        </main>
        <Footer />
        <WhatsappButton />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
      <CookieBanner />
      <Toaster position="top-center" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
